export const BRAND = 'Apres AI';
export const LEGAL_ENTITY = 'Apres AI LLC';
export const ENTITY_FORMATION = 'a Colorado limited liability company';
export const JURISDICTION = 'Colorado, United States';
export const SUPPORT_EMAIL = 'support@apresai.dev';
export const SALES_EMAIL = 'sales@apresai.dev';
export const PARTNERSHIPS_EMAIL = 'partnerships@apresai.dev';
export const PRESS_EMAIL = 'press@apresai.dev';
export const HELLO_EMAIL = 'hello@apresai.dev';
export const LEGAL_EFFECTIVE_DATE = 'April 26, 2026';
export const COPYRIGHT_HOLDER = LEGAL_ENTITY;
